import React from 'react';

const ProcessSection = ({
  processTitle = "EquipoMAG",
  processSubtitle = "Pasos para tomar el control",
  processDescription = "En EquipoMAG, nos esforzamos por construir un futuro más saludable para todos. Nuestro equipo trabaja unido para promover el bienestar y fomentar hábitos alimenticios equilibrados. Estamos aquí para acompañarte en cada paso hacia una vida plena y saludable.",
  contactLink = "mailto:info@equipomag.com",
  contactText = "¡CONTÁCTANOS!",
  steps = [],
}) => {
  return (
    <>
      <section className="prt-row bg-img5 prt-bgimage-yes prt-bg z-index-0 process-section clearfix">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tm-scrollintetx-wrapper Fristss mb-10">
                <div className="big-title">EL PROCESO</div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
              <div className="section-title res-991-mb-0">
                <div className="title-header">
                  <h2 className="title">
                    <span className="title-heading-underline">EquipoMAG.</span> {processSubtitle}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
              <div className="process-desc pl-90 res-1199-pl-0">
                <p className="desc-text">{processDescription}</p>
                <a href={contactLink} className="prt-btn btn-inline prt-btn-color-darkcolor">
                  {contactText}
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            {/* Paso 1 */}
            <div className="col-xl-6 col-lg-6 col-md-12 aos-init aos-animate" data-aos="fade-left" data-aos-offset="200" data-aos-once="true">
              <div className="process-box right-sep mb-60 res-991-mb-10">
                <div className="process-box-thumbnail box-1">
                  <h3 className="clip-image-heading">01</h3>
                </div>
                <div className="process-box-content">
                  <div className="process-box-title">
                    <h3 className="process-box-heading">Primera Consulta</h3>
                  </div>
                  <div className="process-box-desc">
                    <p className="process-box-text">
                      En la primera consulta recipilaremos todos los datos necesarios para crear una disciplina alimentaria más adecuada.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Paso 2 */}
            <div className="col-xl-6 col-lg-6 col-md-12 aos-init aos-animate" data-aos="fade-left" data-aos-offset="200" data-aos-once="true">
              <div className="process-box pl-35 mb-60 res-991-pl-0 res-991-mb-10">
                <div className="process-box-thumbnail box-2">
                  <h3 className="clip-image-heading">02</h3>
                </div>
                <div className="process-box-content">
                  <div className="process-box-title">
                    <h3 className="process-box-heading">Elaboración y envío de la documentación</h3>
                  </div>
                  <div className="process-box-desc">
                    <p className="process-box-text">
                      Con toda la información recopilada crearemos una estrategia a seguir y la enviaremos antes de 24h. Recibirás varios planes y opciones de intercambios.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Paso 3 */}
            <div className="col-xl-6 col-lg-6 col-md-12 aos-init aos-animate" data-aos="fade-right" data-aos-offset="200" data-aos-once="true">
              <div className="process-box right-sep">
                <div className="process-box-thumbnail box-3">
                  <h3 className="clip-image-heading">03</h3>
                </div>
                <div className="process-box-content">
                  <div className="process-box-title">
                    <h3 className="process-box-heading">Seguimimento del proceso</h3>
                  </div>
                  <div className="process-box-desc">
                    <p className="process-box-text">
                      Semanalmente tendremos revisiones para estudiar la evolución e ir actuando en consecuencia. Dando como prioridad la evoliución del porcentage de grasa.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Paso 4 */}
            <div className="col-xl-6 col-lg-6 col-md-12 aos-init aos-animate" data-aos="fade-right" data-aos-offset="200" data-aos-once="true">
              <div className="process-box pl-35 res-991-pl-0">
                <div className="process-box-thumbnail box-4">
                  <h3 className="clip-image-heading">04</h3>
                </div>
                <div className="process-box-content">
                  <div className="process-box-title">
                    <h3 className="process-box-heading">Fase de Mantenimiento</h3>
                  </div>
                  <div className="process-box-desc">
                    <p className="process-box-text">
                      A medida que el porcentage de grasa se vaya acercando al saludable, se realizarn varios cambios hasta entrar en la fase de mantenimiento. En la que ampliaremos la frequencia de las revisiones y se tendrá una total autonomia sobre la alimentación.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProcessSection;
